import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';

import { GroupOrderBagButton } from '../GroupOrderBagButton/GroupOrderBagButton';

// ─────────────────────────────────────────────────────────────────────────────

export const GroupOrderBagLeaveButton = (props: Props) => {
  const { isDisabled, onPress } = props;

  const { formatMessage } = useIntl();

  // ───────────────────────────────────────────────────────────────────────────

  return (
    <GroupOrderBagButton
      accessibilityLabel={formatMessage(messages.label)}
      icon="IconLogout"
      isDisabled={isDisabled}
      onPress={onPress}
    >
      <FormattedMessage {...messages.label} />
    </GroupOrderBagButton>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  label: {
    defaultMessage: 'Leave order',
    description: 'Bag | Group order | Leave group order CTA',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  isDisabled: boolean;
  onPress: () => void;
};
